import { formatPriceNumber } from '@/helpers/number';
import { useAppSelector } from '@/redux/hooks';

export default function useCurrencyFormatter(defaultCurrency = 'USD', minimumFractionDigits = 0, maximumFractionDigits = 2) {
  const currency = useAppSelector((state) => state.auth.companyAccount?.currency) || defaultCurrency;

  return (amount: number = 0) => formatPriceNumber(amount, { currency, minimumFractionDigits, maximumFractionDigits });
}
